export class UrlConstants {
  public static LOGIN = "/login";
  public static HOME = "/layout/dashboard/admin";
  public static REMOTE_LOGIN = "";
  public static REMOTE_HOME = "";
}
